import React from "react";
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { setLessonIsView, fetchLesson, removeCurrentLessons } from "../../../Admin/Lessons/actions";
import { fetchClassRooms } from "../../../School/ClassRooms/actions";
import { clearLessonQuestions } from "../../actions";
import { useLessonItem } from './useLessonItem';
import LessonItemContent from './LessonItemContent';
import CopyLessonModal from './CopyLessonModal';
import ShareLessonModal from './ShareLessonModal';
import SendMissionForm from "../../Forms/SendMissionForm";

const LessonItem = (props) => {
    const user = props.user || props.reduxUser;
    const classRooms = props.classRooms || props.reduxClassRooms;
    const resolvedProps = { ...props, user, classRooms };

    const lessonItemState = useLessonItem(resolvedProps);
    const { lesson, IsAdmin } = resolvedProps;

    if (!lesson) return null;

    const isTeacherOrAssistant = user && user.user && user.user.UserType && (user.user.UserType.Id === 3 || user.user.UserType.Id === 4);

    return (
        <>
            {isTeacherOrAssistant && (
                <>
                    <ShareLessonModal props={resolvedProps} lessonItemState={lessonItemState} />
                    {lessonItemState.showSendMission && (
                        <SendMissionForm
                            {...resolvedProps}
                            handleClose={lessonItemState.handleClose}
                            lesson={lesson}
                            user={user}
                            classRooms={classRooms}
                            SelectedQuestions={lessonItemState.SelectedQuestions}
                            setSelect={lessonItemState.setSelect}
                        />
                    )}
                </>
            )}
            {IsAdmin && <CopyLessonModal props={resolvedProps} lessonItemState={lessonItemState} />}
            <LessonItemContent props={resolvedProps} lessonItemState={lessonItemState} />
        </>
    );
};

const mapStateToProps = state => {
    return {
        lessons: state.lessons,
        lessonQuestions: state.lessonQuestions,
        studentInClassRooms: state.studentInClassRooms,
        reduxUser: state.user,
        reduxClassRooms: state.classRooms
    };
};

export default connect(mapStateToProps, {
    fetchLesson,
    setLessonIsView,
    removeCurrentLessons,
    clearLessonQuestions,
    fetchClassRooms
})(
    withTranslation('common')(LessonItem)
);

